import React from 'react';
import { useSelector } from 'react-redux';

import { Grid } from '@hbf/dsl';
import { FavoriteListingContainer } from 'ha/modules/FavoriteListing';
import { FavoriteButtonNext as FavoriteButton } from 'ha/components/FavoriteButton';
import { SocialShareContainer as SocialShare } from 'ha/modules/SocialShare';
import { SmartTrack as Track } from 'ha/components/track/SmartTrack';
import { useUnitTypeId } from 'ha/modules/MultiUnitListings/hooks';

import { ListingShareButton } from './ListingShareButton';
import { getListingId, getIsMultiUnit, getUnitTypeUnits } from '../selectors';
import { usePageRedesign } from '../hooks/usePageRedesign';

export const ListingActions: React.FC = () => {
  const listingId = useSelector(getListingId);
  const withPageRedesign = usePageRedesign();
  const isMultiUnit = useSelector(getIsMultiUnit);
  const units = useSelector(getUnitTypeUnits);

  const { isUnitTypeId } = useUnitTypeId();

  const analyticsEventProps = React.useMemo(() => {
    return isUnitTypeId
      ? {
          listingId: isMultiUnit ? undefined : units?.[0]?.id, // deprecated
          unitId: isMultiUnit ? undefined : units?.[0]?.id,
          unitTypeId: listingId,
          isMultiUnit,
        }
      : { listingId };
  }, [isUnitTypeId, isMultiUnit, listingId, units]);

  return (
    <Grid
      container
      direction="row"
      spacing={1}
      data-test-locator="ListingActions"
    >
      <SocialShare trackingPayload={analyticsEventProps} isMobile>
        {({ shareTriggerRef, handleShareClick }) => (
          <Grid item>
            <Track
              name="Share clicked"
              type="button"
              getDynamicData={() => analyticsEventProps}
            >
              <ListingShareButton
                ref={shareTriggerRef}
                onClick={handleShareClick}
                data-test-locator="SocialShareTrigger"
              />
            </Track>
          </Grid>
        )}
      </SocialShare>

      <Grid item>
        <FavoriteListingContainer
          listingId={listingId}
          isTenantMULFlowEnabled={isUnitTypeId}
        >
          {({ onClick: onFavoriteClick, isLoading, isFavorite }) => (
            <Track
              name="Favorite clicked"
              type="button"
              getDynamicData={() => ({
                ...analyticsEventProps,
                favoriteType: isFavorite ? 'unfavorite' : 'favorite',
              })}
            >
              <FavoriteButton
                isLoading={isLoading}
                isFavorite={isFavorite}
                onClick={onFavoriteClick}
                data-test-locator="FavoriteTriggerNext"
                iconVariant={withPageRedesign ? 'light' : 'bold'}
              />
            </Track>
          )}
        </FavoriteListingContainer>
      </Grid>
    </Grid>
  );
};
